// extracted by mini-css-extract-plugin
module.exports = {"navbar":"NavBar_navbar__SneNL","items":"NavBar_items__2NMWE","item":"NavBar_item__pNsU-","selectedItem":"NavBar_selectedItem__2ihz4"};